// Component Recommend/RecommendTitle
<template>
  <h3 class="free-title"><span>{{ title || '订阅专栏' }}</span><i v-if="!full">查看往期 ></i></h3>
</template>

<script>
  export default {
    props: ['title', 'full']
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../../style/main";

  $global-width: 750;

  .free-title {
    position: relative;
    width: 100%;
    color: #000;
    height: rem(45);
    font-size: rem(36);
    background-color: #fff;
    font-weight: bold;
    margin-bottom: rem(30);
    span {
      position: absolute;
      bottom: rem(10);
    }

    i {
      position: absolute;
      bottom: rem(18);
      right: rem(30);
      color: #333;
      font-size: rem(24);
      font-weight: bold;
    }
  }
</style>
